import {
  LoadDigestEmail_Item_Create,
  postV1CompaniesCompanyIdLoadDigestsEmails,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import {
  LoadDigestLoadFilter,
  LoadDigestSelection,
  toLoadDigestSelectionBody,
} from '~hooks/useLoadDigests/models';

import sendOutboundEmails, {
  OutboundEmailEntry,
  outboundEmailFields,
} from './sendOutboundEmails';

interface SendLoadDigestEmailsParams {
  companyId: string;
  emails: OutboundEmailEntry[];
  loadFilter: LoadDigestLoadFilter;
  selection: LoadDigestSelection;
}

export default function useLoadDigestOutboundEmails() {
  const sendLoadDigestEmails = useCallback(
    ({ companyId, emails, loadFilter, selection }: SendLoadDigestEmailsParams) => {
      return sendOutboundEmails({
        errorMessage: t('error_messages.load_digests.failed_to_request_email'),
        send: () =>
          postV1CompaniesCompanyIdLoadDigestsEmails({
            path: { 'company-id': companyId },
            body: {
              ...toLoadDigestSelectionBody(selection, loadFilter),
              emails: emails.map((entry): LoadDigestEmail_Item_Create => ({
                ...outboundEmailFields(entry),
                order_ids: entry.ids,
              })),
            },
          }),
      });
    },
    [],
  );

  return { sendLoadDigestEmails };
}
